export default (DB_NAME) => {
    return `${process.env.REACT_APP_BACKEND_PROTOCOL}://${DB_NAME}.${process.env.REACT_APP_BACKEND_URL}`
}